import {
    SHOW_CARRIER_ITEM_CODE_UPLOAD_DIALOG,
    HIDE_CARRIER_ITEM_CODE_UPLOAD_DIALOG,
    FETCH_CARRIER_ITEM_CODE_SUCCESS,
    SORT_CARRIER_ITEM_CODE_LIST,
    CARRIER_ITEM_CODE_FILTER,
    CARRIER_ITEM_CODE_CLEAR_FILTER
} from "../actions/types";

const INITIAL_STATE = {
  list: [],
  filters: {
    countryCode: [],
    carrierCode: '',
    itemCode: '',
    sku: '',
    description: '',
    createdAt: {
        from: null,
        to: null
    }
  },
  sorting: {
    orderBy: 'createdAt',
    sort: 'desc',
  },
  carrierItemCodeUploadDialog: {
    open: false,
    entity: null,
  },
};;

const carrierItemCodeReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SHOW_CARRIER_ITEM_CODE_UPLOAD_DIALOG:
            return {
                ...state,
                carrierItemCodeUploadDialog: {
                    entity: action.payload.entity,
                    open: true
                }
            }
        case HIDE_CARRIER_ITEM_CODE_UPLOAD_DIALOG:
            return {
                ...state,
                carrierItemCodeUploadDialog: {
                    entity: null,
                    open: false,
                }
            }
        case FETCH_CARRIER_ITEM_CODE_SUCCESS:
            return {
                ...state,
                list: action.payload, 
            }
        case SORT_CARRIER_ITEM_CODE_LIST:
            return {
                ...state,
                sorting: action.payload
            }
        case CARRIER_ITEM_CODE_FILTER:
            return {
                ...state,
                filters: {
                ...state.filters,                      
                [action.payload.filterKey]: action.payload.filterValue,
                },
            };
        case CARRIER_ITEM_CODE_CLEAR_FILTER:
            return {
                ...state,
                filters: {
                    countryCode: [],
                    carrierCode: '',
                    itemCode: '',
                    sku: '',
                    description: '',
                    createdAt: {
                        from: null,
                        to: null
                    }
                }
            };
        default:
            return state;
    }
}

export default carrierItemCodeReducer;